import { message, Upload } from "antd";
import { documentSVG, delSVG, sucSVG } from "../../../assets/onboarding/SVGs";
import { useState } from "react";

type Props = { fileData: any; setFileData: any };

const UploadPermit = ({ fileData, setFileData }: Props) => {
  const [fileUploaded, setFileUploaded] = useState(false);

  const uploadProps = {
    name: "work_permit",
    accept: ".pdf,.jpg",
    beforeUpload(file: any) {
      const isPdfOrJpg =
        file.type === "application/pdf" || file.type === "image/jpeg";
      if (!isPdfOrJpg) {
        message.error("You can only upload PDF or JPG files!");
        return false; // Prevent the file from being added to the upload list
      }
      const isFileSizeValid = file.size / 1024 / 1024 < 5; // for example, less than 5MB
      if (!isFileSizeValid) {
        message.error("File must be smaller than 5MB!");
        return false;
      }
      // Optionally, handle file directly here or in onChange
      return false; // Return false to prevent automatic upload
    },
    onChange(info: any) {
      if (info.file.status === "done" || !info.file.status) {
        // Adjusted logic for manual handling
        setFileUploaded(true);
        setFileData(info.file);
        message.success(`${info.file.name} file prepared for upload`);
        // AddSalon(info.file);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file preparation failed.`);
        setFileUploaded(false);
      }
    },
  };
  const handleDelete = () => {
    setFileUploaded(false);
    setFileData({});
  };
  return (
    <div className="w-full col-span-2 mt-8">
      {!fileUploaded ? (
        <Upload {...uploadProps} className="w-full">
          <div className="flex flex-col cursor-pointer w-full hover:opacity-90 justify-center items-center bg-[#FBFBFF] border-[1px] border-solid border-color-primary py-6 px-4 rounded-lg">
            <div className="p-2 my-4 max-lg:my-2">{documentSVG}</div>
            <span className="text-color-primary mb-2">Work Permit</span>
            <span className="text-[#75757E]">
              Upload Salon’s work permit doc
            </span>
          </div>
        </Upload>
      ) : (
        <div className="flex flex-col justify-center items-center min-w-[350px] max-lg:min-w-[150px] border-[1px] border-solid border-[#479821] py-6 px-4 rounded-lg max-lg:w-full">
          <div className="p-2 my-4 bg-[#EEF0FF] rounded flex items-center justify-center">
            {sucSVG}
          </div>
          <span className="text-[#479821] mb-2">تم رفع ترخيص العمل بنجاح</span>
          <div className="px-[10px] py-2 mt-2 rounded bg-[#EEF0FF] flex items-center justify-between w-full">
            <span>{fileData.name}</span>
            <span
              className="flex items-center justify-between cursor-pointer"
              onClick={handleDelete}
            >
              {delSVG}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default UploadPermit;
